import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <CardsSection />
        <UpdatesSection />
        <FeaturesSection />
        <RankingSection />
        <AboutSection />
        <CommentsSection />
        <CarouselSection />
        <MediaSection />
        <IndexSection />
        <AppSection />
        <TopicsSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}